import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

const opts = {
  theme: {
    themes: {
      light: {
        primary: '#000000',
        accent: '#009A44',
        error: 'DE0000',
        'secondary-accent': '162e7b',
      },
    },
  },
};

export default new Vuetify(opts);